export default __webpack_public_path__ + "static/media/GoodMannersWithYourFriends_01.863c191d.png";